var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoFullColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "72px",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_full-color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo_Usage",
    transform: "translate(-192.000000, -114.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-/-full-color",
    transform: "translate(192.000000, 114.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy-8",
    transform: "translate(36.000000, 36.000000) scale(-1, 1) translate(-36.000000, -36.000000) "
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-5",
    fill: "#00909B",
    points: "24 0 48 0 36 24"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-5-Copy-4",
    fill: "#00BC96",
    points: "0 48 24 48 12 72"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-5-Copy-2",
    fill: "#00909B",
    points: "48 48 72 48 60 72"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Page-1",
    fill: "#134873",
    points: "48 0 36 23.999 48 48 72 48"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Page-1-Copy",
    fill: "#12BEDA",
    points: "24 48 36 72 60 72 48 48"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Page-1",
    fill: "#008F70",
    transform: "translate(18.000000, 36.000000) scale(-1, 1) translate(-18.000000, -36.000000) ",
    points: "0 24 12 48 36 48 24 24"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFullColor);
export default __webpack_public_path__ + "static/media/logo_full-color.3b82618a5e91818b4d14ab4ca5ca370e.svg";
export { ForwardRef as ReactComponent };